import loadable from '@loadable/component';

export const OrgDashboardPreviewInternshipPageLoadable = loadable(
  () => import('./OrgDashboardPreviewInternshipPage'),
  { resolveComponent: (module) => module.OrgDashboardPreviewInternshipPage },
);
